import React from 'react';
import glamorous from 'glamorous';

import { media, font } from '../../styles';
import { propTypes, defaultProps } from './types';

export const rules = {
  fontWeight: 400,
  fontSize: font.getFontSize(1.125),
  lineHeight: font.getLineHeight(1.11111111),

  [media('sm')]: {
    fontSize: font.getFontSize(1.5),
    lineHeight: font.getLineHeight(1.22222222),
  },
};

const style = props => ({
  ...rules,
  fontWeight: props.weight || rules.fontWeight,
  marginTop: props.marginTop,
  marginBottom: props.marginBottom,
  textAlign: props.align,
  color: props.color ? props.theme[props.color].base : undefined,
  ...props.glamStyle,
});

const baseStyle = style({});
const H4 = glamorous.h4(baseStyle, style);

class Headline extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <H4 {...rest} glamStyle={style}>
        {children}
      </H4>
    );
  }
}

export default Headline;



// WEBPACK FOOTER //
// ./src/components/typography/Headline.js